module.exports = __webpack_public_path__ + "img/INGLeS.dd264013.png";